var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowOnlyMyEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 14.5003V13.0559C15.5 12.2897 15.2366 11.5549 14.7678 11.0131C14.2989 10.4714 13.663 10.167 13 10.167H8C7.33696 10.167 6.70107 10.4714 6.23223 11.0131C5.76339 11.5549 5.5 12.2897 5.5 13.0559V14.5003",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.27778C11.8807 7.27778 13 5.98438 13 4.38889C13 2.7934 11.8807 1.5 10.5 1.5C9.11929 1.5 8 2.7934 8 4.38889C8 5.98438 9.11929 7.27778 10.5 7.27778Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.49947L0.5 6.5M6 6.49947L3.24991 3.5M6 6.49947L3.24991 9.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowOnlyMyEvents);
export default __webpack_public_path__ + "static/media/show_only_my_events.502385972529c6b067fc4270b3872987.svg";
export { ForwardRef as ReactComponent };